import { render, staticRenderFns } from "./ServiceJp.pug?vue&type=template&id=7246daca&scoped=true&lang=pug&"
import script from "./ServiceJp.vue?vue&type=script&lang=js&"
export * from "./ServiceJp.vue?vue&type=script&lang=js&"
import style0 from "./ServiceJp.scss?vue&type=style&index=0&id=7246daca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246daca",
  null
  
)

export default component.exports